import type { Plan } from '@thom/folio-domain/core/domain/plan'
import type { Live } from '@thom/folio-domain/core/ports/live'
import type { PlanQuery } from '@thom/folio-domain/core/ports/plans'
import { Collections } from '@thom/folio-ui/pocketbase-types'
import { columns, toPlan } from './plans-adapter'
import type { Realtime } from './realtime'
import { sortExpr } from './sort'

const MAX_ROWS = 500

const createPlansLive = ({ client, connection }: Realtime): Live<Plan, PlanQuery> => ({
	source: { client, collection: Collections.JournPlans, map: toPlan, connection },
	options: ({ project, filter }) => ({
		filter: columns(project, filter),
		sort: sortExpr(filter.sort, '-created'),
		perPage: filter.limit ?? MAX_ROWS,
	}),
})

export { createPlansLive }
